import { useEffect, useState } from "react";
import { Button, Col, Row } from "react-bootstrap";
import { AvField, AvForm } from "availity-reactstrap-validation";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import Select from "react-select";
import ParkingService from "../../../../services/ParkingService";
import DriversService from "../../../../services/DriversService";
import QrCodeParkingService from "../../../../services/QrCodeParkingService";
import { Translate } from "../../../Enums/Tranlate";
import { carColors } from "../../../Enums/Fixed";
import QrCodeValetService from "../../../../services/QrCodeValetService";
import QrCodeGroupingService from "../../../../services/QrCodeGroupingService";
import Loader from "../../../common/Loader";

const CodeParking = () => {
	let initial = {
		qr_group: "",
		valet_id: "",
		vehicle_number: "",
		vehicle_color: "",
		driver_id: "",
		parking_id: "",
	};
	const [formData, setFormData] = useState(initial);
	// Per-field validation state for the react-select inputs.
	const [errors, setErrors] = useState({});
	const [loadingPage, setLoadingPage] = useState(false);
	const [loading, setLoading] = useState(false);
	const [valetOptions, setValetOptions] = useState([]);
	const [driversOptions, setDriversOptions] = useState([]);
	const [groupingOptions, setGroupingOptions] = useState([]);
	const [shouldUpdate, setShouldUpdate] = useState([]);
	const lang = useSelector((state) => state.auth.lang);
	const qrCodeGroupingService = new QrCodeGroupingService();
	const qrCodeParkingService = new QrCodeParkingService();
	const qrCodeValetService = new QrCodeValetService();
	const driversService = new DriversService();

	useEffect(() => {
		setLoadingPage(true);
		Promise.all([
			qrCodeGroupingService?.getList(),
			driversService.getList(),
		]).then((res) => {
			let data = [];
			if (res[0]?.status === 200) {
				data = res[0]?.data?.data?.data?.map((info) => {
					return {
						label: info?.name,
						value: info?.id,
					};
				});
				setGroupingOptions(data);
			}
			if (res[1]?.status === 200) {
				data = res[1]?.data?.data?.data?.map((info) => {
					return {
						label: info?.username,
						value: info?.id,
					};
				});
				setDriversOptions(data);
			}
			setLoadingPage(false);
		});
	}, []);

	useEffect(() => {
		if (!!formData?.qr_group?.value) {
			qrCodeValetService
				.getList({ qr_group_id: formData?.qr_group?.value })
				.then((res) => {
					let data = [];
					if (res?.status === 200) {
						data = res?.data?.data?.data?.map((info) => {
							return {
								label: info?.number,
								value: info?.parking?.id,
							};
						});
						setValetOptions(data);
					}
				});
		}
	}, [formData?.qr_group]);

	useEffect(() => {
		setFormData(initial);
		setErrors({});
	}, [shouldUpdate]);
	console.log(formData);
	const submit = (e) => {
		e.preventDefault();

		// react-select fields are invisible to AvForm's `required` rules, so
		// they have to be validated by hand. vehicle_number is an AvField and
		// is already blocked by AvForm before submit ever runs.
		const nextErrors = {};
		if (!formData?.valet_id?.value) nextErrors.valet_id = true;
		if (!formData?.driver_id?.value) nextErrors.driver_id = true;
		if (!formData?.vehicle_color?.value) nextErrors.vehicle_color = true;

		setErrors(nextErrors);
		if (Object.keys(nextErrors).length || !formData?.vehicle_number) {
			toast.error(Translate[lang].field_required);
			return;
		}
		let data = {
			vehicle_color: formData?.vehicle_color?.value,
			vehicle_number: formData?.vehicle_number,
			driver_id: formData?.driver_id?.value,
			parking_id: formData?.valet_id?.value,
		};

		setLoading(true);
		qrCodeParkingService
			.create(data)
			?.then((res) => {
				if (res?.status === 201) {
					toast.success(Translate[lang].added_successfully);
					setShouldUpdate((prev) => !prev);
				}
				setLoading(false);
			})
			.catch(() => setLoading(false));
	};

	if (loadingPage) {
		return <Loader />;
	}

	return (
		<div>
			<AvForm className="form-horizontal" onValidSubmit={submit}>
				<Row>
					<Col md={12} className="mb-2">
						<div className="d-flex justify-content-between">
							<p
								className="mb-0"
								style={{
									fontWeight: "600",
									color: "#333",
									fontSize: "20px",
								}}>
								{Translate[lang]?.add} {Translate[lang]?.qr_parking}
							</p>
						</div>
					</Col>
					{/* Code Group */}
					<Col md={6} className="mb-3">
						<label className="text-label">
							{Translate[lang]?.qr_code_group}
							<span className="star-require">*</span>
						</label>
						<Select
							value={formData?.qr_group}
							name="qr_group"
							placeholder={Translate[lang]?.select}
							options={groupingOptions}
							onChange={(e) =>
								setFormData({
									...formData,
									qr_group: e,
								})
							}
						/>
					</Col>
					{/* QR Code Valet */}
					<Col md={6} className="mb-3">
						<label className="text-label">
							{Translate[lang]?.qr_code_valet}
							<span className="star-require">*</span>
						</label>
						<Select
							value={formData?.valet_id}
							name="valet_id"
							placeholder={Translate[lang]?.select}
							options={valetOptions}
							onChange={(e) => {
								setFormData({
									...formData,
									valet_id: e,
								});
								setErrors((prev) => ({ ...prev, valet_id: false }));
							}}
						/>
						{errors?.valet_id && (
							<span className="star-require d-block mt-1">
								{Translate[lang].field_required}
							</span>
						)}
					</Col>
					{/* Driver */}
					<Col md={6} className="mb-3">
						<label className="text-label">
							{Translate[lang]?.driver}
							<span className="star-require">*</span>
						</label>
						<Select
							value={formData?.driver_id}
							name="driver_id"
							placeholder={Translate[lang]?.select}
							options={driversOptions}
							onChange={(e) => {
								setFormData({ ...formData, driver_id: e });
								setErrors((prev) => ({ ...prev, driver_id: false }));
							}}
						/>
						{errors?.driver_id && (
							<span className="star-require d-block mt-1">
								{Translate[lang].field_required}
							</span>
						)}
					</Col>
					{/* Vehicle Number */}
					<Col md={6}>
						<label className="text-label">
							{Translate[lang]?.vehicle_number}
							<span className="star-require">*</span>
						</label>
						<AvField
							type="text"
							placeholder={Translate[lang]?.vehicle_number}
							bsSize="lg"
							name="vehicle_number"
							validate={{
								required: {
									value: true,
									errorMessage: Translate[lang].field_required,
								},
							}}
							value={formData.vehicle_number}
							onChange={(e) =>
								setFormData({
									...formData,
									vehicle_number: e.target.value,
								})
							}
						/>
					</Col>
					{/* Vehicle Color */}
					<Col md={6} className="mb-3">
						<label className="text-label">
							{Translate[lang]?.vehicle_color}
							<span className="star-require">*</span>
						</label>
						<Select
							value={formData?.vehicle_color}
							name="vehicle_color"
							placeholder={Translate[lang]?.select}
							options={carColors}
							onChange={(e) => {
								setFormData({ ...formData, vehicle_color: e });
								setErrors((prev) => ({ ...prev, vehicle_color: false }));
							}}
						/>
						{errors?.vehicle_color && (
							<span className="star-require d-block mt-1">
								{Translate[lang].field_required}
							</span>
						)}
					</Col>
					<Col md={6}></Col>
					<Col md={6} className="mt-4">
						<Button
							variant="primary"
							type="submit"
							className="w-100"
							disabled={loading}>
							{Translate[lang]?.add} {Translate[lang]?.qr_parking}
						</Button>
					</Col>
				</Row>
			</AvForm>
		</div>
	);
};

export default CodeParking;
